module.exports = __webpack_public_path__ + "img/Group 14备份@2x.2a0c3fca.png";